import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "reload" }, [
  /*#__PURE__*/_createElementVNode("g", { id: "Icon" }, [
    /*#__PURE__*/_createElementVNode("path", {
      id: "Ellipse 4",
      d: "M20.1568 8.19644C19.2306 6.21018 17.6114 4.63014 15.6031 3.75274C13.5949 2.87534 11.3354 2.76088 9.24874 3.43083C7.16207 4.10079 5.39155 5.50913 4.26936 7.39161C3.14717 9.2741 2.75044 11.5014 3.15358 13.6556C3.55673 15.8098 4.73205 17.7428 6.45904 19.0921C8.18604 20.4414 10.346 21.1141 12.5338 20.9842C14.7215 20.8542 16.7866 19.9304 18.3417 18.3861C19.8968 16.8419 20.835 14.7832 20.9802 12.5965",
      "stroke-linecap": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      id: "Arrow",
      d: "M20.6036 4.77029L20.177 8.2442L16.7031 7.81766",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }